export default __webpack_public_path__ + "static/media/i_bus-gen_bl_tagless.894aeb42.svg";